import { Dispatch } from "react";
import API from "../../services/api";
import { Tab } from "typings";
import { createStatusMessage } from "../ui/StatusMessage";
import { statusAdd } from "../ui/action";

export interface LoadTabsAction
{
    type: "LOAD_TABS_SUCCESS";
    tabs: Tab[];
}

export const loadTabs = () => async (dispatch: Dispatch<any>) =>
{
   
    try 
    {
        const tabs = await API.tab.getTabs();
        const action: LoadTabsAction = {type: "LOAD_TABS_SUCCESS", tabs};
        dispatch(action);
    }
    catch (e)
    {
        const statusFinished = createStatusMessage("Loading tabs failed", "error", "product");
        dispatch(statusAdd(statusFinished));
    }
};

export type TabActions = LoadTabsAction;


// WEBPACK FOOTER //
// ./src/state/tab/action.ts